import { usePaginatedQuery, useUrlPaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";

import {
  AdminLicenseAssignmentFilters,
  ListAdminLicenseAssignmentsResponseItem,
} from "./licenseAssignments.types";

export const ADMIN_LICENSE_ASSIGNMENTS_ENDPOINT =
  "v1/admin/license-assignments";
export const ADMIN_LICENSE_ASSIGNMENTS_QUERY_KEY = [
  "admin",
  "license-assignments",
];

const ADMIN_LICENSE_ASSIGNMENTS_FILTER_KEYS: (keyof AdminLicenseAssignmentFilters)[] =
  ["complex", "structure", "module", "user", "sortBy", "sortOrder"];

export const useLicenseAssignmentsQuery = (
  params?: PaginatedQueryParams<AdminLicenseAssignmentFilters>,
  options?: { enabled?: boolean },
) => {
  return usePaginatedQuery<
    ListAdminLicenseAssignmentsResponseItem,
    AdminLicenseAssignmentFilters
  >({
    endpoint: ADMIN_LICENSE_ASSIGNMENTS_ENDPOINT,
    queryKeyBase: ADMIN_LICENSE_ASSIGNMENTS_QUERY_KEY,
    params,
    enabled: options?.enabled,
  });
};

export const useLicenseAssignmentsUrlQuery = () => {
  return useUrlPaginatedQuery<
    ListAdminLicenseAssignmentsResponseItem,
    AdminLicenseAssignmentFilters
  >({
    endpoint: ADMIN_LICENSE_ASSIGNMENTS_ENDPOINT,
    queryKeyBase: ADMIN_LICENSE_ASSIGNMENTS_QUERY_KEY,
    filterKeys: ADMIN_LICENSE_ASSIGNMENTS_FILTER_KEYS,
  });
};
